import * as React from 'react';
import './index.css';
import i18nClient from '../../my_coupon_list/locales/i18n.config';

interface IState {
  showView: boolean;
}

interface props {
  emptyText: string;
}

/**
 * 券列表（我的券列表、历史券列表、提单券列表）兜底页
 */
export default class EmptyView extends React.Component<any, IState> {
  state: IState = {
    showView: false
  }

  render() {
    // @ts-ignore
    return (
      <view>
        <view className="container">
          <view className="empty-wrap">
            <image className="empty-icon" src="assets://market/coupon_list_empty_icon.png" />
            <text className="empty-text">{this.props.emptyText}</text>
          </view>
        </view>
      </view>
    );
  }
}
